import { createFileRoute } from '@tanstack/react-router'

import { ApplicantCaseDetailPage } from '@/pages/dashboard/applicants/case-detail/page'

import { getCaseHistoryListQuery } from '@/lib/queries/business/v1/case/queries'

export const Route = createFileRoute('/_dashboard/applicants/$applicantId/cases/$caseNumber')({
  loader: ({ context: { queryClient }, params: { caseNumber } }) => {
    void queryClient.ensureQueryData(getCaseHistoryListQuery(caseNumber))
  },
  component: ApplicantCaseDetailPage,
})
